<template>
  <div>
    <confirm-modal
        v-model="modalRemoverMidia"
        @modalAcaoCancelar="fecharModalExcluirMidia"
        @modalAcaoConfirmar="excluirMidia"
        :persistencia="false"
        mensagemInicial="Deseja realmente excluir essa mídia?"/>
    <v-dialog
        v-model="model"
        fullscreen
        hide-overlay
        transition="fade-transition"
        content-class="dialog-midia"
    >
      <v-card class="card-midia">

        <!-- Área da imagem -->
        <div
            class="container-imagem"
            @wheel="zoomScroll"
            @touchstart="touchStart"
            @touchend="touchEnd"
        >
          <!-- Fechar -->
          <v-tooltip right>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="fecharModal" class="botao-fechar" outlined icon
                     color="white">
                <v-icon>arrow_back</v-icon>
              </v-btn>
            </template>
            Voltar
          </v-tooltip>


          <!-- Botão anterior -->
          <v-btn icon class="nav-btn left" @click="anterior">
            <v-icon large color="white">mdi-chevron-left</v-icon>
          </v-btn>

          <!-- Imagem -->
          <v-img
              :src="createUrl(midiaAtual.url)"
              class="imagem"
              :style="{ transform: `scale(${zoom})` }"
              contain
              @dblclick="toggleZoom"
          />

          <!-- Botão próxima -->
          <v-btn icon class="nav-btn right" @click="proxima">
            <v-icon large color="white">mdi-chevron-right</v-icon>
          </v-btn>


          <!-- Container acoes -->
          <div class="acoes-container">
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="baixarFoto" icon color="white" class="mr-2">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              Baixar
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="abrirModalConfirmarExcluir" class="botao-excluir-midia" icon color="white">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              Remover da galeria
            </v-tooltip>
          </div>

        </div>

        <!-- Informações -->
        <v-card-text class="info-container">
          <h3>{{ midiaAtual.nome }}</h3>
          <div><strong>Data envio:</strong> {{ midiaAtual.dataEnvio | filterDataHora }}</div>
        </v-card-text>

      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import ConfirmModal from '@/views/components/ConfirmModal.vue'
import {actionTypes} from '@/core/constants'

export default {
    name: 'ModalVisualizarMidia',
    components: {ConfirmModal},
    props: {
        value: Boolean,
        midias: Array,
        indexInicial: Number
    },
    data() {
        return {
            index: this.indexInicial || 0,
            zoom: 1,
            touchX: 0,
            modalRemoverMidia: false
        }
    },
    computed: {
        model: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        },
        midiaAtual() {
            return this.midias[this.index] || {}
        }
    },
    mounted() {
        window.addEventListener('keydown', this.keyNavigation)
    },
    beforeDestroy() {
        window.removeEventListener('keydown', this.keyNavigation)
    },
    methods: {
        fecharModal() {
            this.model = false
            this.zoom = 1
            this.$emit('fecharModalVisualizarMidia')
        },
        fecharModalAtualizar() {
            this.$emit('buscarMidias')
            this.fecharModal()
        },
        proxima() {
            if (!this.midias.length) return
            this.index = (this.index + 1) % this.midias.length
            this.zoom = 1
        },
        anterior() {
            if (!this.midias.length) return
            this.index = (this.index - 1 + this.midias.length) % this.midias.length
            this.zoom = 1
        },
        keyNavigation(e) {
            if (!this.model) return
            if (e.key === 'ArrowRight') this.proxima()
            if (e.key === 'ArrowLeft') this.anterior()
            if (e.key === 'Escape') this.fecharModal()
        },
        toggleZoom() {
            this.zoom = this.zoom === 1 ? 2 : 1
        },
        zoomScroll(e) {
            e.preventDefault()
            if (e.deltaY < 0) {
                this.zoom += 0.2
            } else {
                this.zoom = Math.max(1, this.zoom - 0.2)
            }
        },
        touchStart(e) {
            this.touchX = e.changedTouches[0].screenX
        },
        touchEnd(e) {
            const delta = e.changedTouches[0].screenX - this.touchX
            if (delta > 50) this.anterior()
            if (delta < -50) this.proxima()
        },
        async baixarFoto() {
            const input = {
                url: this.midiaAtual.url,
                nome: this.midiaAtual.nome
            }
            await this.$store.dispatch(actionTypes.FILE_MANAGER.BAIXAR_ARQUIVO, input)
        },
        abrirModalConfirmarExcluir() {
            this.modalRemoverMidia = true
        },
        fecharModalExcluirMidia() {
            this.modalRemoverMidia = false
        },
        async excluirMidia() {
            await this.$store.dispatch(actionTypes.GALERIA_PACIENTE.REMOVER_MIDIA_PACIENTE, this.midiaAtual.id)
            this.mostrarNotificacaoSucesso('Foto removida com sucesso!')
            this.fecharModalExcluirMidia()
            this.fecharModalAtualizar()
        }
    }
}
</script>

<style scoped lang="stylus">

.dialog-midia
  background rgba(0, 0, 0, .95)

.card-midia
  height 100vh
  display flex
  flex-direction column
  background #000

.container-imagem
  flex 1
  display flex
  align-items center
  justify-content center
  position relative
  overflow hidden

.imagem
  transition transform .25s ease
  max-height 90vh
  cursor zoom-in

.nav-btn
  position absolute
  top 50%
  transform translateY(-50%)
  background rgba(0, 0, 0, .4)
  color #fff
  z-index 1

  &.left
    left 20px

  &.right
    right 20px

.nav-btn:hover
  cursor pointer

.info-container
  background #111
  color #fff !important
  padding 16px
  text-align center

.botao-fechar
  position absolute
  top 20px
  left 20px
  color #fff
  z-index 1


.acoes-container
  position absolute
  top 20px
  right 20px
  z-index 1

.botao-excluir-midia:hover
  color red !important


</style>